var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetStartAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.84424,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#00789E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.84424,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#005F7C",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5002 29.1777V33.8444M33.5002 38.5111H33.5118M45.1668 33.8444C45.1668 40.2877 39.9435 45.5111 33.5002 45.5111C27.0568 45.5111 21.8335 40.2877 21.8335 33.8444C21.8335 27.4011 27.0568 22.1777 33.5002 22.1777C39.9435 22.1777 45.1668 27.4011 45.1668 33.8444Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetStartAlert);
export default __webpack_public_path__ + "static/media/asset-start-alert.58a4c729a087eaf116cbe2fd4a70a950.svg";
export { ForwardRef as ReactComponent };